"use client";

import { create } from "zustand";
import type { UserMe } from "@chotca/sdk";

type AuthState = {
  user: UserMe | null;
  hydrated: boolean;
  activeOrgId: string | null;
  setUser: (user: UserMe | null) => void;
  setActiveOrg: (orgId: string | null) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  hydrated: false,
  activeOrgId: null,
  setUser: (user) =>
    set((s) => ({
      user,
      hydrated: true,
      activeOrgId:
        s.activeOrgId ??
        (user?.memberships.length ? user.memberships[0]!.orgId : null),
    })),
  setActiveOrg: (activeOrgId) => set({ activeOrgId }),
  clear: () => set({ user: null, hydrated: true, activeOrgId: null }),
}));
